import { ParametrosPortalEnum } from 'src/app/content/pages/enums/parametros.enum';
import { ParametroPortalService } from 'src/app/content/pages/services/parametro-portal.service';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import * as objectPath from 'object-path';
import { MenuConfigService } from './menu-config.service';
import { LayoutConfigService } from './layout-config.service';
import { AuthenticationService } from 'src/app/core/auth';
import { AuthInfoService } from '../../pages/services/auth-info.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class MenuAsideService {
    classes: string;
    private menuList$: BehaviorSubject<any[]> = new BehaviorSubject([]);

    isDropdown = 0;
    dropdownTimeout: number;
    isScrollable = 0;

    constructor(
        private menuConfigService: MenuConfigService,
        private layoutConfigService: LayoutConfigService,
        private parametroPortalService: ParametroPortalService,
        private authenticationService: AuthenticationService,
        private authInfoService: AuthInfoService
    ) {
        // get menu list
        this.menuConfigService.onMenuUpdated$.subscribe(model => {
              this.menuList$.next(objectPath.get(model.config, 'aside.items'))
              this.obterParametros();
              this.validarExibicaoMenuMaxInsights();
        });

        this.layoutConfigService.onLayoutConfigUpdated$.subscribe(config => {
            if (objectPath.get(config, 'config.aside.left.fixed')) {
                this.isScrollable = 1;
                this.isDropdown = 0;
            }

            if (!objectPath.get(config, 'config.aside.left.fixed')
                && !objectPath.get(config, 'config.menu.aside.desktop_and_mobile.submenu.accordion')) {
                this.isScrollable = 0;
                this.isDropdown = 1;
                this.dropdownTimeout = objectPath.get(config, 'config.menu.aside.desktop_and_mobile.submenu.dropdown.hover_timeout');
            }
        });
    }


  obterParametros() {
    forkJoin(
      this.parametroPortalService.obterParametroEspecifico({id: ParametrosPortalEnum.TRABALHAR_TRANSPORTADORA}),
      this.parametroPortalService.obterParametroEspecifico({id: ParametrosPortalEnum.SOLICITA_AUT_VL_ADICIONAL_TAB_FRETE}),
      this.parametroPortalService.getTrabalhaComImportacaoExcel(),
      this.parametroPortalService.obterParametroEspecifico({id: ParametrosPortalEnum.ACESSO_TELA_GERACAO_GEOLOCALIZACAO})
    ).subscribe(([paramTransportadora, paramSolicitaAutVlAd
                       , importacaoExcel, paramTelaGeolocalizacaoMassa]) => {

      if (paramTransportadora.valor === 'N') {
        const indiceMenuCadastro = this.menuList$.value.findIndex(menu => menu.title === 'Cadastros');
        if (indiceMenuCadastro !== -1) {
          const indiceSubMenuGeracao = this.menuList$.value[indiceMenuCadastro].submenu
            .findIndex(submenu => submenu.title === 'Transportadoras');
          if (indiceSubMenuGeracao !== -1) {
            this.menuList$.value[indiceMenuCadastro].submenu.splice(indiceSubMenuGeracao, 1);
          }
        }
      }
      if (!importacaoExcel) {
        const indiceMenuCadastro = this.menuList$.value.findIndex(menu => menu.title === 'Importar Arquivo');
        if (indiceMenuCadastro !== -1) {
          const indiceSubMenuGeracao = this.menuList$.value[indiceMenuCadastro].submenu
            .findIndex(submenu => submenu.title === 'EXCEL');
          if (indiceSubMenuGeracao !== -1) {
            this.menuList$.value[indiceMenuCadastro].submenu.splice(indiceSubMenuGeracao, 1);
          }
        }
      }
      if (paramSolicitaAutVlAd.valor === 'N') {
        const indiceMenuCadastro = this.menuList$.value.findIndex(menu => menu.title === 'Autorizações');
        if (indiceMenuCadastro !== -1) {
          this.menuList$.value.splice(indiceMenuCadastro, 1);
        }
      }
      if (paramTelaGeolocalizacaoMassa.valor === 'N') {
        const indiceMenuCadastro = this.menuList$.value.findIndex(menu => menu.title === 'Configurações');
        if (indiceMenuCadastro !== -1) {
          const indiceSubMenuGeracao = this.menuList$.value[indiceMenuCadastro].submenu
            .findIndex(submenu => submenu.title === 'Geração de coordenadas/Geocode');
          if (indiceSubMenuGeracao !== -1) {
            this.menuList$.value[indiceMenuCadastro].submenu.splice(indiceSubMenuGeracao, 1);
          }
        }
      }

      this.atualizarMenuList();
    });
  }

  atualizarMenuList() {
    this.menuList$.next(this.menuList$.value);
  }

  async validarExibicaoMenuMaxInsights() {
    const indiceMenuCadastro = this.menuList$.value.findIndex(menu => menu.title === 'MaxInsights');

    const ofertas = await this.authInfoService.getOfertasPorCliente("21").toPromise();

    if(!ofertas || ofertas.length === 0) {
      return;
    }

    if(ofertas[0].status === 'L') {
      this.menuList$.value[indiceMenuCadastro].dialog = false;
      this.menuList$.value[indiceMenuCadastro].msgSemAcesso = 'No momento, você não possui uma licença disponível para acessar o MaxInsights.';
      this.atualizarMenuList();
    }

    if(ofertas[0].status != 'A') {
      return;
    }

    this.menuList$.value[indiceMenuCadastro].page = `${environment.maxInsightsUrl}/?PWE=${this.authenticationService.obtenhaToken()}`;
    this.menuList$.value[indiceMenuCadastro].dialog = false;
    this.atualizarMenuList();
  }

  getMenuListAsObservable() {
    return this.menuList$.asObservable();
  }

  getMenuList() {
    return this.menuList$.getValue();
  }

}
